/* dwl-smart-filter.js — slimme filterchips op collectiepagina's.
   Chips komen uit de collectie zelf (<url>?view=dwl-filter):
   - thema's waar minstens 2 eendjes van deze collectie in zitten, maar niet (bijna) allemaal;
     gesorteerd op hoe vaak ze voorkomen, met een duwtje voor thema's van eendjes die deze
     bezoeker eerder bekeek (localStorage dwl_viewed);
   - prijsband, Nieuw (laatste 90 dagen) en Op voorraad — alleen als ze iets wegfilteren.
   Filteren gebeurt meteen: ontbrekende pagina's worden op de achtergrond opgehaald
   (Section Rendering API) zodat je altijd de hele collectie filtert, niet alleen pagina 1.
   Keuze staat in de URL (?thema=<id>) zodat een gefilterde link deelbaar is.
   2-11-2026 (v7) — slimmer, niet drukker:
   - geen dubbele chips meer (twee chips met (bijna) dezelfde eendjes → alleen de meest specifieke);
   - max 6 thema-chips; wat in je mandje zit en wat je bekeek telt mee in de volgorde;
   - bij 'Aanbevolen': uitverkocht naar achteren, en (alleen als we iets van je weten) max 4
     eendjes die passen bij wat je bekeek / in je mandje hebt naar voren;
   - eendjes in je mandje krijgen een klein label.
   - zoekintentie-chips (Bruiloft, Zee & water, Superhelden...) op basis van wat mensen in Google zoeken. */
(function () {
  var nav = document.querySelector('[data-dsf]');
  if (!nav) return;
  var grid = document.querySelector('.section-products .products-list');
  var wrap = document.querySelector('.section-products .products[data-id]');
  if (!grid || !wrap) return;

  var top = document.querySelector('.section-products-top');
  if (top && top.parentNode) top.parentNode.insertBefore(nav, top);

  var T = {};
  ['all', 'stock', 'new', 'under', 'mid', 'from', 'count', 'one', 'loading', 'incart'].forEach(function (k) {
    T[k] = nav.getAttribute('data-t-' + k) || '';
  });

  /* Brede/technische collecties: nooit als chip (te algemeen of intern) */
  var SKIP = { '295510507729': 1, '299814289617': 1, '299992613073': 1, '301646872785': 1, '299992645841': 1, '301646151889': 1 };
  var SKIP_URL = /bundle|pool|most-loved|bestseller|\/all$|frontpage/;
  /* seizoens- en buiten-seizoen-thema's nooit als chip (geen Halloween/kerst/WK enz. in onze eigen content) */
  var SKIP_SEASON = /hallowe|spooky|griezel|gruselig|effrayant|terror|christmas|kerst|weihnacht|noel|navidad|sinterklaas|valentin|zodiac|sterrenbeeld|horoscop|astro|football|voetbal|fussball|soccer|futbol/i;

  /* zoekintenties: wat mensen echt zoeken (Search Console, 6 mnd), gematcht op titel + handle + tags.
     [id, regex, labels nl|en|de|fr|es, vertoningen in Google] */
  var INTENTS = [
    ['wedding', /\b(bride|groom|wedding|bruid|bruidegom|bachelor|married|just-married|hochzeit|mariage|boda)/, "Bruiloft|Wedding|Hochzeit|Mariage|Boda", 0],
    ['baby', /(pregnan|zwanger|baby|toddler|todler|its-a-boy|its-a-girl|it's a (boy|girl)|newborn|swimmama|mama|papa|grandma|grandpa|family)/, "Baby & familie|Baby & family|Baby & Familie|Bébé & famille|Bebé y familia", 328],
    ['love', /\b(love|heart|hearts|kiss|saranghaey|loveduck|lovegirl|loveman|lovely)/, "Liefde|Love|Liebe|Amour|Amor", 381],
    ['getwell', /(get-well|get well|beterschap|nurse|doctor|dokter|health|wellness)/, "Beterschap & zorg|Get well & care|Gute Besserung|Bon rétablissement|Que te mejores", 101],
    ['party', /(birthday|party|present|cake|champagne|celebrat|feest|verjaardag|finish|graduat)/, "Feestje|Party time|Party|Fête|Fiesta", 96],
    ['sea', /\b(crab|octopus|shark|sharky|turtle|fish|whale|dolphin|seal|lobster|jellyfish|mermaid|sailor|pirate|diver|swim)/, "Zee & water|Sea & water|Meer & Wasser|Mer & eau|Mar y agua", 3416],
    ['safari', /\b(giraffe|lion|zebra|rhino|hippo|elephant|leopard|tiger|koala|panda|monkey|gorilla|kangaroo|bison|crocodile)/, "Safari & wild|Safari & wild|Safari & Wildnis|Safari & sauvage|Safari y salvaje", 2326],
    ['pets', /\b(cat|dog|kitty|pussycat|puppy|bunny|rabbit|hamster)\b|cat-|dog-|cow|sheep|pig|horse|chicken|farm/, "Huisdieren & boerderij|Pets & farm|Haustiere & Bauernhof|Animaux de ferme|Mascotas y granja", 285],
    ['bugs', /\b(bee|bees|butterfly|ladybug|spider|ant|ants|froggie|frog|scorpio|scorpion)\b|spider|butterfl|ladybug/, "Kriebelbeestjes|Creepy crawlies|Krabbeltiere|Petites bêtes|Bichos", 1962],
    ['fantasy', /(dragon|unicorn|monster|wizard|witch|fairy|angel|myth|legend|knight|lancelot|viking|gladiat)/, "Draken & fantasy|Dragons & fantasy|Drachen & Fantasy|Dragons & fantaisie|Dragones y fantasía", 2165],
    ['dino', /(dino|saurus|rex|raptor|anodon|ceratops|jurassic)/, "Dino’s|Dinosaurs|Dinos|Dinosaures|Dinosaurios", 609],
    ['hero', /\b(hero|super|bat-|saranghaey|flying-man|actionman|action man|captain|defender|trooper)/, "Superhelden|Superheroes|Superhelden|Super-héros|Superhéroes", 1556],
    ['movies', /(movie|film|trooper|skydefender|skyfighter|gangster|famous)/, "Film & iconen|Movies & icons|Film & Ikonen|Cinéma & icônes|Cine e iconos", 240],
    ['care', /(dentist|surgeon|nurse|doctor|clara|annie|health)/, "Zorg|Healthcare|Gesundheit|Santé|Salud", 66],
    ['build', /(bricklayer|plumber|mechanic|handyman|painter|plasterer|windowcleaner|carwash|repair|builder|construction|electric|tyre)/, "Bouw & techniek|Trades|Handwerk|Artisans|Oficios", 225],
    ['office', /(lawyer|judge|business|scientist|teacher|nerd|laptop|police|fire|fireman|pilot|flyer|captain|chef|waiter|baker|cook)/, "Uniform & kantoor|Uniform & office|Uniform & Büro|Uniforme & bureau|Uniforme y oficina", 891],
    ['sport', /(football|soccer|tennis|golf|basket|hockey|snowboard|cycl|bicycle|bike|marathon|runner|fitness|boxing|mma|crawl|surf|skate|raceduck|race-duck|racer|darts|dart-man|\bski\b|skis)/, "Sport|Sports|Sport|Sport|Deporte", 1693],
    ['music', /(music|guitar|drum|piano|violin|singer|opera|dj|rock|trumpet|bass|mariachi|vinyl)/, "Muziek|Music|Musik|Musique|Música", 380],
    ['food', /(pizza|donut|cake|cheese|beer|wine|coffee|sushi|burger|ice-cream|icecream|champagne|baguette|cherry|food)/, "Eten & drinken|Food & drink|Essen & Trinken|Cuisine|Comida", 198],
    ['holland', /(holland|dutch|delft|amsterdam|tulip|mokum|volendam|cheese|clog|windmill|amsterman)/, "Hollands|Dutch|Holländisch|Hollandais|Holandés", 721],
    ['travel', /(travel|holiday|globetrotter|world|city|new-york|paris|london|munich|cologne|frankfurt|tokyo|flyer|suitcase)/, "Reizen & steden|Travel & cities|Reisen & Städte|Voyages & villes|Viajes y ciudades", 464],
    ['history', /(farao|pharao|cleopatra|nefertiti|toetanchamon|egypt|roman|gladiat|knight|viking|history|samurai|ninja)/, "Geschiedenis|History|Geschichte|Histoire|Historia", 329],
    ['glitter', /(glitter|gold|bling|silver|crown|luxury|ceramic)/, "Glitter & goud|Glitter & gold|Glitzer & Gold|Paillettes & or|Brillo y oro", 230],
    ['art', /(art-|artduck|art duck|gogh|art-colour|painter|museum)/, "Kunst|Art|Kunst|Art|Arte", 107],
    ['crypto', /(bitcoin|ethereum|crypto|xrp|solana|cardano|pepe|doge)/, "Crypto|Crypto|Krypto|Crypto|Cripto", 311],
    ['xl', /(xl|xxl|big|giant|large|30cm|30-cm|jumbo)/, "Groot formaat|Big ducks|Große Enten|Grands canards|Patos grandes", 0]
  ];

  /* reeksen & figuren (2-11-2026): veel gerichter dan de brede thema's. [id, regex op de HANDLE (niet op tags!), labels nl|en|de|fr|es] */
  var SERIES = [
    ['delft', /^(delft-blue|dutch-blue|ceramic-blue)$/, "Delfts blauw|Delft blue|Delfter Blau|Bleu de Delft|Azul Delft"],
    ['tulip', /^tulip-/, "Tulpen|Tulips|Tulpen|Tulipes|Tulipanes"],
    ['masters', /^(rembrandt|van-gogh|pearl-girl|picasso)$/, "Oude meesters|Old masters|Alte Meister|Grands maîtres|Grandes maestros"],
    ['artduck', /^art-duck-/, "Art Ducks|Art Ducks|Art Ducks|Art Ducks|Art Ducks"],
    ['mokumhero', /^(amsterdam-defender|amsterman|mokum-girl|mini-mokumgirl)$/, "Amsterdamse helden|Amsterdam heroes|Amsterdamer Helden|Héros d’Amsterdam|Héroes de Ámsterdam"],
    ['space', /^(trooper-black|trooper-white|skydefender|skyfighter|green-wonder|mini-green-wonder|mando|robot-gold|baba-duck)$/, "Ruimtesaga|Space saga|Weltraumsaga|Saga spatiale|Saga espacial"],
    ['gangsters', /^(peaky-blinder|shelby|tommy|arthur)$/, "Jaren-20 gangsters|1920s gangsters|Gangster der 20er|Gangsters des années 20|Gánsteres de los años 20"],
    ['spider', /^(actionman-red|super-actionman|dark-actionman|mini-actionman-red)$/, "Spinnenhelden|Spider heroes|Spinnenhelden|Héros araignée|Héroes araña"],
    ['bat', /^(saranghaey-boy|saranghaey-girl|mini-actionman-black-white)$/, "Vleermuishelden|Bat heroes|Fledermaushelden|Héros chauve-souris|Héroes murciélago"],
    ['cape', /^(loveman|lovegirl|hero-girl|lightning-man|cat-lady|flying-man|flying-man-small|mokum-girl|mini-mokumgirl)$/, "Superhelden met cape|Caped heroes|Helden mit Umhang|Héros à cape|Héroes con capa"],
    ['egypt', /^(cleopatra|farao|nefertiti|toetanchamon|mummy)$/, "Oud-Egypte|Ancient Egypt|Altes Ägypten|Égypte antique|Antiguo Egipto"],
    ['mermaid', /mermaid|redhair-girl/, "Zeemeerminnen|Mermaids|Meerjungfrauen|Sirènes|Sirenas"],
    ['pirate', /^(mini-pirate|mini-pirate-sable|pirate-parrot|captain-(vidd|hook|rob|bluehead))$/, "Piraten|Pirates|Piraten|Pirates|Piratas"],
    ['winter', /piste|ski|snowboard|winnie-winter|icehockey/, "Wintersport|Winter sports|Wintersport|Sports d’hiver|Deportes de invierno"],
    ['bees', /^(maya-the-bee|willi-the-bee|billy-bee|bibi-bee|mini-bee)$/, "Bijtjes|Bees|Bienen|Abeilles|Abejas"],
    ['frogs', /frog/, "Kikkers|Frogs|Frösche|Grenouilles|Ranas"],
    ['mexico', /^(mariachi-|mexi-)/, "Viva México|Viva México|Viva México|Viva México|Viva México"],
    ['knights', /^(king-arthur|lancelot|gladiatore|ragnar)$/, "Ridders & strijders|Knights & warriors|Ritter & Krieger|Chevaliers & guerriers|Caballeros y guerreros"],
    ['dragons', /dragon/, "Draken|Dragons|Drachen|Dragons|Dragones"],
    ['unicorn', /unicorn/, "Eenhoorns|Unicorns|Einhörner|Licornes|Unicornios"],
    ['doctors', /^(nurse-ziggy|doctor-annie|doctor-clara|doctor-health|carla-nurse|nicey-nurse|ernst-surgeon|darry-dentist|dr-duck|dr-rossi)$/, "Dokters & zusters|Doctors & nurses|Ärzte & Pflege|Médecins & infirmières|Médicos y enfermeras"],
    ['racing', /^(ducks-on-wheels-|max-red|raceduck-|blue-racer|red-racer)/, "Racen|Racing|Rennsport|Course|Carreras"],
    ['sweets', /^(duckcake-|donutduck-)/, "Taartjes & donuts|Cakes & donuts|Kuchen & Donuts|Gâteaux & donuts|Pasteles y donuts"],
    ['bling', /^blingbling-/, "BlingBling|BlingBling|BlingBling|BlingBling|BlingBling"],
    ['glitter', /^(mini-)?glitter-/, "Glitter|Glitter|Glitzer|Paillettes|Purpurina"],
    ['crown', /^(gold-crown-|crown-yellow)/, "Met kroontje|With a crown|Mit Krone|Avec couronne|Con corona"],
    ['legends', /^(elvis|elvis-detailed|piano-man|guitar-man|jimmy-guitar|micro-man|marilyn)$/, "Muzieklegendes|Music legends|Musiklegenden|Légendes de la musique|Leyendas de la música"],
    ['icons', /^(einstein|einstein-detailed|trump-duck|barack-barista|samuel|mike)$/, "Beroemdheden|Famous faces|Berühmtheiten|Célébrités|Famosos"],
    ['dutchlegends', /^(johan-blue|johan-light-blue|johan-white-football|micro-man|max-red|dart-man)$/, "Nederlandse legendes|Dutch legends|Niederländische Legenden|Légendes néerlandaises|Leyendas neerlandesas"],
    ['football', /^(amsterdam-football|holland-football|argentina-football|croatia-football|barcelona-football|spain-football|football|football-fan-yellow|german-fan|icecold-football-fan|lady-football|referee-red-card|johan-.*)$/, "Voetbal|Football|Fußball|Football|Fútbol"],
    ['cycling', /^(cyclist|bert-cyclist|billy-bicycle)$/, "Fietsen & wielrennen|Cycling|Radsport|Cyclisme|Ciclismo"],
    ['swim', /^(swimmama-blue|swimmama-pink|swimmama-yellow|sjimmie-swim|sjimmie-swim-ring|gerry-crawl|daly-diver|jim-surfer)$/, "Zwemmen & surfen|Swim & surf|Schwimmen & Surfen|Natation & surf|Natación y surf"],
    ['fight', /^(mike|mike-mma|mexi-wrestler-red|hammer)$/, "Vechtsport|Combat sports|Kampfsport|Sports de combat|Deportes de combate"],
    ['fitness', /^(dumble-man|willow-workout|marathon|triathlon|olympia|yogaboy|yogagirl|britt|juliette|yamay)$/, "Fitness & yoga|Fitness & yoga|Fitness & Yoga|Fitness & yoga|Fitness y yoga"],
    ['ballsport', /^(barry-basketball|gert-golf|tina-tennis)$/, "Golf, tennis & basketbal|Golf, tennis & basketball|Golf, Tennis & Basketball|Golf, tennis & basket|Golf, tenis y baloncesto"],
    ['hunting', /^(hunting-harry|harper-hunter)$/, "Op jacht|Hunting|Jagd|Chasse|Caza"],
    ['minis', null, "Mini’s|Minis|Minis|Minis|Minis"]
  ];
  function isMini(it, txt) { return it.p > 0 && it.p <= 700 && !/keychain|sleutel/.test(txt); }
  var LI = ({ nl: 0, en: 1, de: 2, fr: 3, es: 4 })[(nav.getAttribute('data-lang') || 'en').slice(0, 2)] || 0;
  if ((nav.getAttribute('data-lang') || 'en').slice(0, 2) === 'en') LI = 1;

  var path = location.pathname.replace(/\/$/, '');
  var KEY = 'dwl_flt_v11_' + path;
  var seg = decodeURIComponent(path.split('/').pop() || '').toLowerCase();
  var accPage = /keychain|accessor|bag/.test(path.toLowerCase());

  function store(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function viewed() {
    try { return JSON.parse(localStorage.getItem('dwl_viewed') || '[]'); } catch (e) { return []; }
  }
  function slug(u) {
    var m = String(u || '').split('?')[0].match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function getData() {
    var cached = store(KEY);
    if (cached) { try { var c = JSON.parse(cached); if (c && c.items) return Promise.resolve(c); } catch (e) {} }
    function page(n) {
      return fetch(path + '?view=dwl-filter&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); });
    }
    return page(1).then(function (d) {
      if (d.pages <= 1) return d;
      var rest = [];
      for (var i = 2; i <= Math.min(d.pages, 6); i++) rest.push(page(i));
      return Promise.all(rest).then(function (more) {
        more.forEach(function (m) {
          d.items = d.items.concat(m.items || []);
          for (var k in (m.cols || {})) d.cols[k] = m.cols[k];
        });
        return d;
      });
    }).then(function (d) {
      store(KEY, JSON.stringify(d));
      return d;
    });
  }

  /* ---------- alle kaarten in het raster krijgen ---------- */
  var extraLoaded = null;
  var pager = wrap.querySelector('.products-pagination, products-pagination');
  function loadAllCards() {
    if (extraLoaded) return extraLoaded;
    var pages = 1;
    var btn = wrap.querySelector('[data-total-pages]');
    if (btn) pages = parseInt(btn.getAttribute('data-total-pages'), 10) || 1;
    else if (pager) {
      pager.querySelectorAll('a, span').forEach(function (el) {
        var n = parseInt(el.textContent, 10); if (n > pages) pages = n;
      });
    }
    var cur = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
    var sid = wrap.getAttribute('data-id');
    var sp = new URLSearchParams(location.search);
    var reqs = [];
    for (var i = 1; i <= Math.min(pages, 25); i++) {
      if (i === cur) continue;
      sp.set('page', i); sp.set('section_id', sid);
      reqs.push(fetch(path + '?' + sp.toString()).then(function (r) { return r.text(); }).catch(function () { return ''; }));
    }
    extraLoaded = Promise.all(reqs).then(function (htmls) {
      var have = {};
      grid.querySelectorAll('.products-list-item').forEach(function (li) { have[cardSlug(li)] = 1; });
      htmls.forEach(function (h) {
        if (!h) return;
        var doc = new DOMParser().parseFromString(h, 'text/html');
        doc.querySelectorAll('.products-list .products-list-item').forEach(function (li) {
          var s = cardSlug(li);
          if (!s || have[s]) return;
          have[s] = 1;
          li.setAttribute('data-dsf-extra', '');
          li.hidden = true;
          li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
          /* het thema laat foto's pas zien als zijn lazy-loader ze 'ziet'; die kent deze kaarten niet */
          li.querySelectorAll('figure.lazy-loading-image').forEach(function (f) { f.classList.add('lazy-loaded-image'); });
          li.querySelectorAll('img[aria-hidden="true"]').forEach(function (img) { img.setAttribute('aria-hidden', 'false'); });
          grid.appendChild(li);
        });
      });
    });
    return extraLoaded;
  }
  function cardSlug(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? slug(a.getAttribute('href')) : '';
  }

  /* ---------- chips bouwen ---------- */
  var DATA, BYSLUG = {}, CHIPS = [], CART = {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { var m = {}; (c.items || []).forEach(function (l) { m[l.product_id] = 1; }); return m; })
      .catch(function () { return {}; });
  }
  var state = { theme: null, price: null, stock: false, fresh: false };

  function build(d) {
    DATA = d;
    var items = d.items || [];
    var n = items.length;
    if (n < 6) return false;
    items.forEach(function (it) {
      BYSLUG[slug(it.u)] = it;
      var txt = String(it.t || '').toLowerCase();
      var hd = slug(it.u).toLowerCase();
      it.ix = [];
      /* reeksen alleen op de handle; sleutelhangers tellen niet mee, behalve op een sleutelhanger-/accessoirepagina */
      if (accPage || hd.indexOf('keychain') < 0) SERIES.forEach(function (x) { if (x[1] ? x[1].test(hd) : isMini(it, hd)) it.ix.push('i-s-' + x[0]); });
      INTENTS.forEach(function (x) { if (/(^|\s)thema-/.test(txt) ? new RegExp('(^|\\s)thema-' + x[0] + '(\\s|$)').test(txt) : x[1].test(txt)) it.ix.push('i-' + x[0]); });
    });

    var seen = {}, hot = {};
    viewed().forEach(function (h) { var it = BYSLUG[h]; if (it) it.c.concat(it.ix).forEach(function (c) { seen[c] = (seen[c] || 0) + 1; }); });
    items.forEach(function (it) { if (CART[it.i]) it.c.concat(it.ix).forEach(function (c) { hot[c] = (hot[c] || 0) + 1; }); });

    var count = {};
    items.forEach(function (it) { it.c.forEach(function (c) { count[c] = (count[c] || 0) + 1; }); });
    var themes = [];
    Object.keys(count).forEach(function (id) {
      var col = d.cols[id];
      if (!col || String(id) === String(d.id) || SKIP[id] || SKIP_URL.test(col[1]) || SKIP_SEASON.test(col[0] + ' ' + col[1])) return;
      var k = count[id];
      if (k < (n >= 15 ? 3 : 2) || k > n * 0.85) return;
      var score = k * 2.5 + 4 * (seen[id] || 0) + 6 * (hot[id] || 0);
      themes.push({ id: id, label: col[0], n: k, score: score, size: col[2] || 9999 });
    });
    /* zoekintentie-chips (bv. Bruiloft, Zee & water, Superhelden) — gewogen naar wat er in Google gezocht wordt */
    INTENTS.forEach(function (x) {
      var id = 'i-' + x[0], k = 0;
      items.forEach(function (it) { if (it.ix.indexOf(id) > -1) k++; });
      if (k < 2 || k > n * 0.85) return;
      if (SKIP_SEASON.test(x[2])) return;
      var w = 1 + Math.log(1 + x[3]) / Math.LN10;
      var score = k * w + 4 * (seen[id] || 0) + 6 * (hot[id] || 0);
      themes.push({ id: id, label: x[2].split('|')[LI] || x[2].split('|')[1], n: k, score: score, size: k });
    });
    /* reeks-chips gaan voor: die zijn het meest gericht */
    SERIES.forEach(function (x) {
      var id = 'i-s-' + x[0], k = 0;
      items.forEach(function (it) { if (it.ix.indexOf(id) > -1) k++; });
      if (k < 2 || k > n * 0.8) return;
      if (x[1] && x[1].test(seg)) return;
      if (x[0] === 'minis' && /mini/.test(path)) return;
      var score = k * 4 + 12 + 4 * (seen[id] || 0) + 6 * (hot[id] || 0) - (x[0] === 'minis' ? 14 : 0);
      themes.push({ id: id, label: x[2].split('|')[LI] || x[2].split('|')[1], n: k, score: score, size: k });
    });
    var LOW = { '297892774097': 1, '295562150097': 1, '297891692753': 1 }; themes.sort(function (a, b) { return (LOW[a.id] ? 1 : 0) - (LOW[b.id] ? 1 : 0) || b.score - a.score || a.label.localeCompare(b.label); });
    /* dubbelingen eruit: (bijna) dezelfde eendjes → houd de meest specifieke collectie */
    var sets = {};
    themes.forEach(function (t) {
      sets[t.id] = {};
      items.forEach(function (it) { if (has(it, t.id)) sets[t.id][it.u] = 1; });
    });
    function inside(a, b) { var A = sets[a], B = sets[b], both = 0, na = 0, k; for (k in A) { na++; if (B[k]) both++; } return both / Math.max(na, 1); } function overlap(a, b) {
      var A = sets[a], B = sets[b], both = 0, na = 0, nb = 0, k;
      for (k in A) { na++; if (B[k]) both++; }
      for (k in B) nb++;
      return both / Math.max(na, nb, 1);
    }
    var kept = [];
    themes.forEach(function (t) {
      for (var j = 0; j < kept.length; j++) { if (String(t.id).indexOf('i-') !== 0 && String(kept[j].id).indexOf('i-') === 0 && (inside(kept[j].id, t.id) >= 0.6 || inside(t.id, kept[j].id) >= 0.6)) { return; } if (String(t.id).indexOf('i-') === 0 && (inside(t.id, kept[j].id) >= 0.7 || t.label.toLowerCase() === kept[j].label.toLowerCase())) return;
        if (overlap(t.id, kept[j].id) >= 0.8) {
          if (t.size < kept[j].size) kept[j] = t;
          return;
        }
      }
      kept.push(t);
    });
    /* v7: reeks binnen reeks (>= 80% van de ene zit in de andere) -> houd de grotere/specifiekere */
    function isSer(t) { return String(t.id).indexOf('i-s-') === 0; }
    kept = kept.filter(function (t, i) {
      if (!isSer(t)) return true;
      return !kept.some(function (u, j) {
        return j !== i && isSer(u) && inside(t.id, u.id) >= 0.8 && (t.size < u.size || (t.size === u.size && j < i));
      });
    });
    /* v7: brede chip (thema of collectie) weg als de gekozen reeks-chips samen al >= 60% ervan dekken */
    var union = {};
    kept.forEach(function (t) { if (String(t.id).indexOf('i-s-') === 0) for (var u in sets[t.id]) union[u] = 1; });
    kept = kept.filter(function (t) {
      if (String(t.id).indexOf('i-s-') === 0) return true;
      var na = 0, cov = 0;
      for (var u in sets[t.id]) { na++; if (union[u]) cov++; }
      return !na || cov / na < 0.6;
    });
    /* v7: nooit twee chips met (bijna) hetzelfde label ("Art" / "Art Ducks", "Glitter" / "Glitter & goud") — houd de meest specifieke */
    function lab(l) { return String(l).toLowerCase().replace(/[^a-z0-9À-ɏ ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
    function near(a, b) {
      var A = lab(a), B = lab(b), fa = A.split(' ')[0], fb = B.split(' ')[0];
      return A === B || A.indexOf(B + ' ') === 0 || B.indexOf(A + ' ') === 0 || (fa === fb && fa.length >= 3);
    }
    function spec(t) { var id = String(t.id); return id.indexOf('i-s-') === 0 ? 0 : (id.indexOf('i-') === 0 ? 2 : 1); }
    var uniq = [];
    kept.forEach(function (t) {
      for (var j = 0; j < uniq.length; j++) {
        if (!near(t.label, uniq[j].label)) continue;
        if (spec(t) < spec(uniq[j]) || (spec(t) === spec(uniq[j]) && t.size < uniq[j].size)) uniq[j] = t;
        return;
      }
      uniq.push(t);
    });
    themes = uniq.slice(0, 9);
    personal(items, seen, hot, n);

    var lo = 0, mid = 0, hi = 0, out = 0, fresh = 0;
    var cutoff = Date.now() / 1000 - 90 * 86400;
    items.forEach(function (it) {
      if (it.p < 1500) lo++; else if (it.p <= 2500) mid++; else hi++;
      if (!it.a) out++;
      if (it.d > cutoff) fresh++;
    });
    var prices = [];
    if (lo >= 2 && lo < n * 0.85) prices.push({ id: 'lo', label: T.under, n: lo });
    if (mid >= 2 && mid < n * 0.85) prices.push({ id: 'mid', label: T.mid, n: mid });
    if (hi >= 2 && hi < n * 0.85) prices.push({ id: 'hi', label: T.from, n: hi });

    if (!themes.length && prices.length < 2 && !out) return false;

    var row = nav.querySelector('[data-dsf-row]');
    var html = '<button type="button" class="dsf__chip is-on" data-k="all">' + esc(T.all) + '</button>';
    themes.forEach(function (t) {
      html += '<button type="button" class="dsf__chip" data-k="theme" data-v="' + t.id + '">' + esc(t.label) + ' <span>' + t.n + '</span></button>';
    });
    if (fresh >= 2 && fresh < n) html += '<button type="button" class="dsf__chip" data-k="fresh">' + esc(T['new']) + ' <span>' + fresh + '</span></button>';
    if (prices.length >= 2) prices.forEach(function (p) {
      html += '<button type="button" class="dsf__chip dsf__chip--price" data-k="price" data-v="' + p.id + '">' + esc(p.label) + ' <span>' + p.n + '</span></button>';
    });
    if (out >= Math.max(3, n * 0.08) && out < n) html += '<button type="button" class="dsf__chip dsf__chip--stock" data-k="stock">' + esc(T.stock) + ' <span>' + (n - out) + '</span></button>';
    row.innerHTML = html;
    nav.hidden = false;
    return true;
  }

  /* ---------- slimme volgorde + label 'in je mandje' (alleen huidige pagina, alleen bij Aanbevolen) ---------- */
  function personal(items, seen, hot, n) {
    tagCart();
    var sort = new URLSearchParams(location.search).get('sort_by');
    if (sort && sort !== 'manual') return;
    var lis = Array.prototype.slice.call(grid.querySelectorAll('.products-list-item:not([data-dsf-extra])'));
    if (lis.length < 4) return;
    var broad = {};
    Object.keys(DATA.cols || {}).forEach(function (id) {
      var col = DATA.cols[id];
      if (String(id) === String(DATA.id) || SKIP[id] || SKIP_URL.test(col[1])) broad[id] = 1;
    });
    var vset = {};
    viewed().forEach(function (h) { vset[h] = 1; });
    var know = Object.keys(seen).length || Object.keys(hot).length;
    /* v7: alleen gewone eenden mogen naar voren (geen mini's, accessoires of cadeaus), en alleen als ze niet al in de eerste 8 staan */
    var miniCol = '';
    Object.keys(DATA.cols || {}).forEach(function (id) { if (/\/collections\/minis$/.test(DATA.cols[id][1] || '')) miniCol = id; });
    function regular(it) {
      var txt = String(it.t || '');
      if (!(it.p > 700) || /keychain-sharky|(^|[\s-])gift([\s-]|$)/.test(txt)) return false;
      if (/(^|\s)mini-/.test(txt) || (miniCol && (it.c.indexOf(parseInt(miniCol, 10)) > -1 || it.c.indexOf(miniCol) > -1))) return false;
      return !/\b(keychain|keyring|sleutelhanger|bag|tas|totebag|bobblehead|doorstop|door stopper|deurstopper|sticker|stickers)\b/.test(txt);
    }
    var scored = lis.map(function (li, idx) {
      var it = BYSLUG[cardSlug(li)], aff = 0;
      if (it && know && idx >= 8 && regular(it) && !CART[it.i] && !vset[cardSlug(li)]) {
        it.c.concat(it.ix || []).forEach(function (c) { if (!broad[c]) aff += (seen[c] || 0) + 2 * (hot[c] || 0); });
      }
      return { li: li, idx: idx, aff: aff, out: it ? !it.a : false };
    });
    var boost = scored.filter(function (s) { return s.aff >= 2 && !s.out; })
      .sort(function (a, b) { return b.aff - a.aff || a.idx - b.idx; }).slice(0, 3);
    var bset = boost.map(function (b) { return b.li; });
    var rest = scored.filter(function (s) { return bset.indexOf(s.li) === -1; });
    var order = bset.concat(rest.filter(function (s) { return !s.out; }).map(function (s) { return s.li; }))
      .concat(rest.filter(function (s) { return s.out; }).map(function (s) { return s.li; }));
    var changed = order.some(function (li, i) { return li !== lis[i]; });
    if (!changed) return;
    var anchor = lis[lis.length - 1].nextSibling;
    order.forEach(function (li) { grid.insertBefore(li, anchor); });
    /* extra (verborgen) kaarten blijven achteraan */
    grid.querySelectorAll('.products-list-item[data-dsf-extra]').forEach(function (li) { grid.appendChild(li); });
  }
  function tagCart() {
    if (!T.incart) return;
    grid.querySelectorAll('.products-list-item').forEach(function (li) {
      var it = BYSLUG[cardSlug(li)];
      var on = !!(it && CART[it.i]);
      var tag = li.querySelector('.dsf-tag');
      if (on && !tag) {
        var box = li.querySelector('.products-list-item__labels') || li.querySelector('.products-list-item__top');
        if (!box) return;
        tag = document.createElement('span');
        tag.className = 'dsf-tag';
        tag.textContent = T.incart;
        box.appendChild(tag);
      } else if (!on && tag) tag.parentNode.removeChild(tag);
    });
  }
  document.addEventListener('dwl:cart-updated', function (e) {
    var c = e && e.detail;
    if (!c || !c.items) return;
    CART = {};
    c.items.forEach(function (l) { CART[l.product_id] = 1; });
    if (DATA) tagCart();
  });

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function has(it, id) {
    id = String(id);
    if (id.indexOf('i-') === 0) return (it.ix || []).indexOf(id) > -1;
    return it.c.indexOf(parseInt(id, 10)) > -1 || it.c.indexOf(id) > -1;
  }
  function match(it) {
    if (!it) return false;
    if (state.theme && !has(it, state.theme)) return false;
    if (state.price === 'lo' && !(it.p < 1500)) return false;
    if (state.price === 'mid' && !(it.p >= 1500 && it.p <= 2500)) return false;
    if (state.price === 'hi' && !(it.p > 2500)) return false;
    if (state.stock && !it.a) return false;
    if (state.fresh && !(it.d > Date.now() / 1000 - 90 * 86400)) return false;
    return true;
  }

  function active() { return !!(state.theme || state.price || state.stock || state.fresh); }

  function apply() {
    nav.querySelectorAll('.dsf__chip').forEach(function (b) {
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      var on = k === 'all' ? !active()
        : k === 'theme' ? state.theme === v
        : k === 'price' ? state.price === v
        : k === 'stock' ? state.stock
        : k === 'fresh' ? state.fresh : false;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var countEl = nav.querySelector('[data-dsf-count]');
    if (!active()) {
      grid.querySelectorAll('.products-list-item').forEach(function (li) { li.hidden = li.hasAttribute('data-dsf-extra'); });
      if (pager) pager.hidden = false;
      countEl.textContent = '';
      syncUrl();
      return;
    }
    countEl.textContent = T.loading;
    loadAllCards().then(function () {
      var shown = 0;
      grid.querySelectorAll('.products-list-item').forEach(function (li) {
        var ok = match(BYSLUG[cardSlug(li)]);
        li.hidden = !ok;
        if (ok) shown++;
      });
      if (pager) pager.hidden = true;
      tagCart();
      countEl.textContent = shown === 1 ? T.one : T.count.replace('[n]', shown);
      syncUrl();
    });
  }

  function syncUrl() {
    try {
      var sp = new URLSearchParams(location.search);
      if (state.theme) sp.set('thema', state.theme); else sp['delete']('thema');
      var q = sp.toString();
      history.replaceState(null, '', path + (q ? '?' + q : '') + location.hash);
    } catch (e) {}
  }

  nav.addEventListener('click', function (e) {
    var b = e.target.closest('.dsf__chip');
    if (!b) return;
    var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
    /* altijd één chip tegelijk: dan klopt het getal op de chip en kom je nooit op 0 uit */
    var wasOn = b.classList.contains('is-on');
    state = { theme: null, price: null, stock: false, fresh: false };
    if (k !== 'all' && !wasOn) {
      if (k === 'theme') state.theme = v;
      else if (k === 'price') state.price = v;
      else if (k === 'stock') state.stock = true;
      else if (k === 'fresh') state.fresh = true;
    }
    apply();
    if (b.scrollIntoView && window.innerWidth < 750) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  });

  Promise.all([getData(), getCart()]).then(function (r) {
    var d = r[0];
    CART = r[1] || {};
    if (!build(d)) { if (DATA) personal(d.items || [], {}, {}, 0); return; }
    var pre = new URLSearchParams(location.search).get('thema');
    pre = pre ? pre.replace(/[^\w-]/g, '') : '';
    if (pre && nav.querySelector('.dsf__chip[data-v="' + pre + '"]')) {
      state.theme = pre;
      apply();
    }
  }).catch(function () {});
})();
